module.exports = __webpack_public_path__ + "images/rovo_collection_2.77984ecc6702e881def4fc0956531fad.png";